import React, { Component } from 'react';
import config from 'react-global-configuration';
// Importação do Router
import { BrowserRouter, Route, Switch, Link, Redirect} from 'react-router-dom';
// Importação do Bootstrap
import { Tabs, Tab,  Button, Grid, Row, Col, Navbar, NavItem, Nav, MenuItem, NavDropdown } from 'react-bootstrap';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import Topo from '../Layout/Topo';
import Loading from '../Miscelania/Loading';
import Select from 'react-select';
import Alerta from '../Miscelania/Alerta';
import RequestApi from '../Miscelania/RequestApi';
import InputMask from 'react-input-mask';




class ExamsEdit extends Component {
  desativar_loading () {
    this.setState({status_loading: 0});
  } 
  desativar_alerta () {
    this.setState({status_alerta: 0});
  } 
  // Handlers de form e tab
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
  }
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  constructor(props) {
    super(props);

    this.state = {
      redirect_url: false,
      mensagem_alerta: false,
      tipo_alerta: false,
      status_alerta: false,
      name: '',
      nota_minima: '',
      setting_level_id: null,
      question_id: null,
      matter_id: null,
      matter_id_import: null,
      lista_dificuldades: [],
      lista_questoes: [],
      lista_materias: [],
      lista_materias_prova: [],
      time_limit: '',
      qtd_questoes: '',
      dados_materias: [],
      dados_questoes: [],
    };
    //alertas
    this.desativar_alerta = this.desativar_alerta.bind(this);
    this.desativar_loading = this.desativar_loading.bind(this);
    this.verificarMensagem = this.verificarMensagem.bind(this);
    
    //Ações de edição de prova.
    this.listaDificuldades = this.listaDificuldades.bind(this);
    this.prova = this.prova.bind(this);
    this.editar = this.editar.bind(this);
    this.salvar_edicao = this.salvar_edicao.bind(this);
    this.dificuldadeProva = this.dificuldadeProva.bind(this);

    //Ações de adição e deletar questões de prova.
    this.questoes = this.questoes.bind(this);
    this.ListaQuestoes = this.ListaQuestoes.bind(this);
    this.ListaMateriasProva = this.ListaMateriasProva.bind(this);
    this.botaoDeletarQuestoes = this.botaoDeletarQuestoes.bind(this);
    this.adicionarQuestao = this.adicionarQuestao.bind(this);
    this.importarQuestoes = this.importarQuestoes.bind(this);
    this.deletarQuestao = this.deletarQuestao.bind(this);
    this.deletarLinhaQuestao = this.deletarLinhaQuestao.bind(this);
    this.demonstracaoProvas = this.demonstracaoProvas.bind(this);

    //Ações de adição e deletar matérias de prova.
    this.materias = this.materias.bind(this);
    this.ListaMaterias = this.ListaMaterias.bind(this);
    this.botaoDeletarMateria = this.botaoDeletarMateria.bind(this);
    this.adicionarMateria = this.adicionarMateria.bind(this);
    this.deletarMateria = this.deletarMateria.bind(this);
    this.deletarLinhaMateria = this.deletarLinhaMateria.bind(this);
  }

  componentDidMount () {
    this.refs.request_api.verifyPermission();
    var self = this;
    setTimeout(function(){self.verificarMensagem();}, 5);
    this.listaDificuldades();
    this.prova();
    this.ListaMaterias();
    this.ListaMateriasProva();
    this.materias();
    this.questoes();
  }

  verificarMensagem () {
    var mensagem = localStorage.getItem("verifica_mensagem");
    if (mensagem !== null && typeof mensagem !== 'undefined') {
      mensagem = JSON.parse(mensagem);
      var self = this;
      self.setState({status_alerta: 1});
      self.setState({mensagem_alerta: mensagem.mensagem_alerta});
      self.setState({tipo_alerta: mensagem.tipo_alerta});
      localStorage.removeItem("verifica_mensagem");
    }
  }

  //Listagem de dificuldades para edição de prova.
  listaDificuldades(e) {
    var url = config.get('api') + '/prova/dificuldades/listar';
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({lista_dificuldades: responseJson.data});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  // Buscar infos do prova e de sua dificuldade
  prova(e) {
    var url = config.get('api') + '/prova/'+this.props.match.params.id;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.id,
            name: responseJson.data.name,
            setting_level_id: responseJson.data.setting_level_id,
            nota_minima: responseJson.data.nota_minima,
          });
          self.dificuldadeProva();
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  /**
   * busco dados para formulário de edição em modal
   */
  dificuldadeProva(e) {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/prova/dificuldade/view/'+ self.state.setting_level_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({
            time_limit: responseJson.data.time_limit,
            qtd_questoes: responseJson.data.qtd_questoes,
          });
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Editar e gerar alerta
  editar(event) {
    event.preventDefault();
    this.salvar_edicao();
    this.setState({status_alerta: 1});
  }
  
  // Fetch salvando a edição
  salvar_edicao(event) {
    var dados_salvar = {
      id: this.state.id,
      name: this.state.name,
      setting_level_id: this.state.setting_level_id,
      nota_minima: this.state.nota_minima,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/prova', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        self.setState({mensagem_alerta: responseJson.message});
        self.setState({tipo_alerta: responseJson.status});
        self.prova();
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  /**
   * ABA DE MATÉRIAS
   */

  materias(e) {
    var url = config.get('api') + '/prova/materias/'+this.props.match.params.id;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({dados_materias: responseJson.data});
          self.ListaQuestoes();
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  ListaMaterias(e) {
    var url = config.get('api') + '/materias/lista';
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({lista_materias: responseJson.data,});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  adicionarMateria(event) {
    event.preventDefault();
    var dados_salvar = {
      matter_id: this.state.matter_id,
      exam_id: this.props.match.params.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/prova/materia', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          var dados_temp = self.state.dados_materias;
          dados_temp.push(responseJson.data);
          self.setState({dados_materias: dados_temp});
          self.ListaQuestoes();
          self.ListaMateriasProva();
          self.questoes();
        }
        self.setState({status_alerta: 1});
        self.setState({mensagem_alerta: responseJson.message});
        self.setState({tipo_alerta: responseJson.status});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  botaoDeletarMateria (cell, row, enumObject, index) {
    var variavel = (
      /*<BotaoDeletar url={"/prova/materia/"+ cell} />*/
      <button className="btn btn-sm btn-danger" value={cell} onClick={this.deletarMateria}>
        <i className="fa fa-fw fa-trash"></i>
      </button>
    );

    return variavel;
  }

  deletarMateria (event) {
    var exam_matter_id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar essa matéria?');
    if (confirm) {
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/prova/materia/' + exam_matter_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          self.setState({status_alerta: 1});
          self.setState({mensagem_alerta: responseJson.message});
          self.setState({tipo_alerta: responseJson.status});
          if (responseJson.status === 'success') {
            self.deletarLinhaMateria(exam_matter_id);
            self.ListaQuestoes();
            self.ListaMateriasProva();
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  deletarLinhaMateria(exam_matter_id) {
    var dados = this.state.dados_materias;
    dados.map(function(dado, index){
      if (dado.id == exam_matter_id) {
        dados.splice(index, 1);
      }
    });
    this.setState({dados_materias: dados});
  }


  /**
   * ABA DE QUESTÕES
   */

  questoes(e) {
    var url = config.get('api') + '/prova/questoes/buscar_questoes/'+this.props.match.params.id;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({dados_questoes: responseJson.data,});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  //A lista de questões dependerá das matérias adicionadas. <<<<
  ListaQuestoes(e) {
    var url = config.get('api') + '/prova/questoes/lista/' + this.props.match.params.id;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({lista_questoes: responseJson.data,});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  ListaMateriasProva(e) {
    var url = config.get('api') + '/prova/materias/lista/'+ this.props.match.params.id;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({lista_materias_prova: responseJson.data,});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  adicionarQuestao(event) {
    event.preventDefault();
    var dados_salvar = {
      question_id: this.state.question_id,
      exam_id: this.props.match.params.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/prova/questao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          var dados_temp = self.state.dados_questoes;
          dados_temp.push(responseJson.data);
          self.setState({dados_questoes: dados_temp});
        }
        self.setState({status_alerta: 1});
        self.setState({mensagem_alerta: responseJson.message});
        self.setState({tipo_alerta: responseJson.status});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  importarQuestoes(event) {
    event.preventDefault();
    var dados_salvar = {
      matter_id: this.state.matter_id_import,
      exam_id: this.props.match.params.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/prova/importar/questoes', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.questoes();
        }
        self.setState({status_alerta: 1});
        self.setState({mensagem_alerta: responseJson.message});
        self.setState({tipo_alerta: responseJson.status});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  botaoDeletarQuestoes (cell, row, enumObject, index) {
    var variavel = (
      /*<BotaoDeletarQuestoes url={"/prova/questao/"+ cell} />*/
      <button className="btn btn-sm btn-danger" value={cell} onClick={this.deletarQuestao}>
        <i className="fa fa-fw fa-trash"></i>
      </button>
    );

    return variavel;
  }

  deletarQuestao (event) {
    var exam_question_id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar essa questão?');
    if (confirm) {
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/prova/questao/' + exam_question_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          self.setState({status_alerta: 1});
          self.setState({mensagem_alerta: responseJson.message});
          self.setState({tipo_alerta: responseJson.status});
          if (responseJson.status === 'success') {
            self.deletarLinhaQuestao(exam_question_id);
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  deletarLinhaQuestao(exam_question_id) {
    var dados = this.state.dados_questoes;
    dados.map(function(dado, index){
      if (dado.id == exam_question_id) {
        dados.splice(index, 1);
      }
    });
    this.setState({dados: dados});
  }

  demonstracaoProvas(e) {
    var url = config.get('api') + '/prova/gerar_prova/'+ this.props.match.params.id;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          window.open(responseJson.pdf);
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} />
  {(this.state.status_loading != 0) ? <Loading ativo={this.state.status_loading} desativar={this.desativar_loading} /> : ""}
  {(this.state.status_alerta == 1) ? <Alerta mensagem={this.state.mensagem_alerta} tipo={this.state.tipo_alerta} desativar={this.desativar_alerta} /> : ""}
  <div className="container">
    <div className="conteudo">
      <h3 className="page-title pull-left">Editar prova</h3>
      <Link to="/provas/listagem" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id="controlled-tab-example">
        <Tab eventKey={1} title="Dados da prova">
          <form onSubmit={this.editar}>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Nome da prova:</label>
                  <input type="text" name="name" className="form-control" placeholder="Nome da prova" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Nível de dificuldade:</label>
                  <Select
                    className="form-field-name"
                    name="setting_level_id"
                    value={this.state.setting_level_id}
                    searchable={true}
                    placeholder={'Selecione o nível de dificuldade'}
                    onChange={this.handleSelectChange.bind(this, 'setting_level_id')}
                    options={this.state.lista_dificuldades}
                  />    
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Quantidade de questões:</label>
                  <InputMask value={this.state.qtd_questoes}  maskChar={null} name="qtd_questoes" mask="99" className="form-control" disabled="disabled" onChange={this.handleChange.bind(this, 'qtd_questoes')} placeholder="Somente números" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Tempo de prova:</label>
                  <InputMask value={this.state.time_limit} disabled="disabled" maskChar={null} name="time_limit" mask="99" className="form-control" onChange={this.handleChange.bind(this, 'time_limit')} placeholder="Tempo de prova em minutos" />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Nota mínima:</label>
                  <InputMask value={this.state.nota_minima}  maskChar={null} name="nota_minima" mask="99" className="form-control" onChange={this.handleChange.bind(this, 'nota_minima')} placeholder="Somente números" />
                </div>
              </div>
            </div>
            <div className="row">
            <div className="col-md-12">
              <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Editar prova</button>
            </div>
            </div>
          </form>
        </Tab>
        <Tab eventKey={2} title="Matérias">
          <form onSubmit={this.adicionarMateria}>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Matéria:</label>
                  <Select
                    className="form-field-name"
                    name="matter_id"
                    value={this.state.matter_id}
                    searchable={true}
                    placeholder={'Selecionar Matéria'}
                    onChange={this.handleSelectChange.bind(this, 'matter_id')}
                    options={this.state.lista_materias}
                  />    
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <button type="submit" className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-save"></i> Adicionar matéria</button>
                </div>
              </div>
            </div>
          </form>
          <hr/>
          <BootstrapTable data={this.state.dados_materias} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há matérias cadastradas'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

            <TableHeaderColumn isKey={true} dataField="materia" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Matéria</TableHeaderColumn>

            <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoDeletarMateria} width='80'>Ações</TableHeaderColumn>

          </BootstrapTable>
        </Tab>
        <Tab eventKey={3} title="Questões">
           
            <div className="row">
              <div className="col-md-6">
                <div className="row">
                  <form onSubmit={this.adicionarQuestao}>
                    <div className="col-md-12">
                      <h3>Adicionar Questão</h3>
                      <hr/>
                      <div className="form-group">
                        <label>Questões:</label>
                          <Select
                            className="form-field-name"
                            name="question_id"
                            value={this.state.question_id}
                            searchable={true}
                            placeholder={'Selecionar Questão'}
                            onChange={this.handleSelectChange.bind(this, 'question_id')}
                            options={this.state.lista_questoes}
                          />    
                      </div>
                      <button type="submit" className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-save"></i> Adicionar questão</button>
                    </div>
                  </form>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <form onSubmit={this.importarQuestoes}>
                    <div className="col-md-12">
                      <h3>Importar questões da matéria</h3>
                      <hr/>
                      <div className="form-group">
                        <label>Matérias:</label>
                          <Select
                            className="form-field-name"
                            name="matter_id_import"
                            value={this.state.matter_id_import}
                            searchable={true}
                            placeholder={'Selecionar Matéria'}
                            onChange={this.handleSelectChange.bind(this, 'matter_id_import')}
                            options={this.state.lista_materias_prova}
                          />    
                      </div>
                      <button type="submit" className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-save"></i> Importar questões</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          <hr/>
          <BootstrapTable data={this.state.dados_questoes} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há questões cadastradas'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

            <TableHeaderColumn isKey={true} dataField="questao" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Questão</TableHeaderColumn>

            <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoDeletarQuestoes} width='80'>Ações</TableHeaderColumn>

          </BootstrapTable>
        </Tab>
      </Tabs>      
    </div>
  </div>
</div>
    );
  }
}

export default ExamsEdit;



// WEBPACK FOOTER //
// ./src/Components/Exams/ExamsEdit.js